/**
 * Filters Toggle Desktop
 * Handles showing/hiding vertical filters on desktop with localStorage support
 */

class FiltersToggleDesktop {
  constructor() {
    this.buttons = document.querySelectorAll('[data-filters-toggle]');
    this.storageKey = 'filters-visibility';
    
    console.log('[FiltersToggle] Buttons found:', this.buttons.length);
    
    if (this.buttons.length === 0) {
      console.warn('[FiltersToggle] No toggle buttons found');
      return;
    }
    
    this.init();
  }
  
  init() {
    this.buttons.forEach(button => {
      const sectionId = button.dataset.sectionId;
      const rememberState = button.dataset.rememberState === 'true';
      const defaultHidden = button.dataset.defaultHidden === 'true';
      const showText = button.dataset.showText || 'Mostrar filtros';
      const hideText = button.dataset.hideText || 'Ocultar filtros';
      
      // Get filter container
      const filterContainer = document.querySelector(`[data-filters-container][data-section-id="${sectionId}"]`);
      
      console.log('[FiltersToggle] Section ID:', sectionId);
      console.log('[FiltersToggle] Filter container found:', !!filterContainer);
      
      if (!filterContainer) {
        console.warn('[FiltersToggle] Filter container not found for section:', sectionId);
        return;
      }
      
      // Check saved state or use default
      let isHidden = defaultHidden;
      
      if (rememberState) {
        const savedState = localStorage.getItem(`${this.storageKey}-${sectionId}`);
        if (savedState !== null) {
          isHidden = savedState === 'hidden';
        }
      }
      
      // Apply initial state
      this.updateFilterState(filterContainer, button, isHidden, showText, hideText);
      
      // Add click event
      button.addEventListener('click', () => {
        console.log('[FiltersToggle] Button clicked!');
        const currentlyHidden = filterContainer.classList.contains('filters-hidden');
        const newState = !currentlyHidden;
        console.log('[FiltersToggle] Current state:', currentlyHidden ? 'hidden' : 'visible');
        console.log('[FiltersToggle] New state:', newState ? 'hidden' : 'visible');
        
        this.updateFilterState(filterContainer, button, newState, showText, hideText);
        
        // Save state if remember is enabled
        if (rememberState) {
          localStorage.setItem(
            `${this.storageKey}-${sectionId}`,
            newState ? 'hidden' : 'visible'
          );
        }
        
        // Dispatch custom event for other scripts that might need to know
        window.dispatchEvent(new CustomEvent('filters:toggled', {
          detail: {
            sectionId,
            hidden: newState
          }
        }));
      });
    });
  }
  
  updateFilterState(container, button, isHidden, showText, hideText) {
    const textElement = button.querySelector('.facets-toggle-desktop-button__text');
    
    if (isHidden) {
      container.classList.add('filters-hidden');
      if (textElement) textElement.textContent = showText;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', showText);
    } else {
      container.classList.remove('filters-hidden');
      if (textElement) textElement.textContent = hideText;
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', hideText);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FiltersToggleDesktop();
  });
} else {
  new FiltersToggleDesktop();
}

// Re-initialize on Shopify section render (for theme editor)
document.addEventListener('shopify:section:load', () => {
  new FiltersToggleDesktop();
});
